import { get } from "lodash-es";
export function isAxiosError(err) {
  return typeof err === 'object' && get(err, 'isAxiosError') === true;
}
//# sourceMappingURL=axios.js.map
